import { Entry } from '../Entry'

export function Entry20220804() {
  return (
    <Entry title="04/08/2022 - v3.2.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12695/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
